import { formatDisplayDate } from "../../../Helper/functionHelper.js";
import UserInfoCell from "../../../components/common/UserInfoCell.jsx";
const RATE_UNIT_LABEL = {
  DAILY: "/ day",
  WEEKLY: "/ week",
  BIWEEKLY: "/ fortnight",
  HOURLY: "/ hour",
};

const StatusBadge = ({ status }) => {
  const isActive = Number(status) === 1;

  return (
    <span
      className="d-inline-flex align-items-center justify-content-center"
      style={{
        backgroundColor: isActive ? "#219653" : "#b83227",
        color: "#fff",
        fontSize: "11px",
        fontWeight: 600,
        padding: "4px 14px",
        borderRadius: "999px",
        lineHeight: 1,
        whiteSpace: "nowrap",
      }}
    >
      {isActive ? "Active" : "Inactive"}
    </span>
  );
};

const getColumns = (handleEdit, handleDelete) => [
  {
    label: "Employee",
    field: "employee_name",
    className: "fw-semibold",
    sortable: true,
    render: (row) => <UserInfoCell name={row.employee_name} employeeId={row.employee_code} token={row.userToken} />,
  },
  {
    label: "Pay Basis",
    field: "pay_basis",
    sortable: true,
  },
  {
    label: "Rate",
    field: "rate_amount",
    className: "fw-semibold",
    sortable: true,
    render: (row) => `₹${Number(row.rate_amount || 0).toFixed(2)} ${RATE_UNIT_LABEL[row.pay_basis] || ""}`,
  },
  {
    label: "Paid Non-Working Days",
    field: "paid_categories",
    render: (row) => {
      const labels = [
        row.week_off_paid && "Week-off",
        row.holiday_paid && "Holiday",
        row.leave_paid && "Leave",
        row.lwp_paid && "LWP",
      ].filter(Boolean);
      return labels.length ? labels.join(", ") : <span className="text-muted">None (no work, no pay)</span>;
    },
  },
  {
    label: "Effective From",
    field: "effective_from",
    sortable: true,
    render: (row) => formatDisplayDate(row.effective_from),
  },
  {
    label: "Effective To",
    field: "effective_to",
    sortable: true,
    render: (row) => row.effective_to ? formatDisplayDate(row.effective_to) : "Open-ended",
  },
  {
    label: "Status",
    field: "status",
    className: "text-center",
    sortable: false,
    render: (row) => <StatusBadge status={row.status} />,
  },
  {
    label: "Action",
    field: "action",
    className: "fw-semibold text-center",
    sortable: false,
    render: (row) => (
      <div className="d-flex gap-2 justify-content-center">
        <div className="cursor-pointer text-primary" onClick={() => handleEdit(row)} title="Edit">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            edit
          </span>
        </div>
        <div className="cursor-pointer text-danger" onClick={() => handleDelete(row.id)} title="Delete">
          <span className="material-icons-outlined" style={{ fontSize: "20px" }}>
            delete
          </span>
        </div>
      </div>
    ),
  },
];

export default getColumns;
